<template>
  <div>
    <v-btn color="green" dark small @click="openModal">
      <v-icon left small>mdi-plus</v-icon>
      Crea nuevo ganado
    </v-btn>
    <v-dialog v-model="modal" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon class="error--text" @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text max-height="600px" class="pa-0">
         <ingreso :modal.sync="modal" :modoModal="true" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Ingreso from '../views/RU/Ingreso.vue'
export default {
  name: 'ModalIngreso',
  components: {
    Ingreso,
  },
  data: () => {
    return {
      modal: false,
    }
  },

  methods: {
    openModal() {
      this.modal = true
    },
    cerrarModal() {
      this.modal = false
    },
  },
}
</script>
